<template>
  <StandardSearchPageView
    ref="table"
    :col="3"
    :columns="getColumns()"
    :queryParams="queryParams"
    :searchOptions="searchOptions"
    :requestPromise="loadDataList"
  >
  </StandardSearchPageView>
</template>

<script>
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'ProductUpdateComponent',
  mixins: [],
  components: {
    SimpleFormEditorDialog,
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {},
      searchOptions: [
        {
          name: '商品ID',
          key: 'productId',
          type: 'input',
          placeholder: '请输入商品ID'
        },
        {
          name: '商品名称',
          key: 'proName',
          type: 'input',
          placeholder: '请输入商品名称'
        }
      ]
    }
  },

  mounted() {

  },
  methods: {
    loadDataList(params) {
      const requestParams = {
        ...params,
        ...params.limitDto,
        limitDto: undefined,
        merchantId: this.$store.getters.userInfo.merchantId
      }
      return this.getHttpServices().getSourceService().post('shiji/platform/productUpdate_list', requestParams)
    },
    getColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'productId',
          width: '100px'
        },
        {
          title: '石基酒店代码',
          dataIndex: 'shijiHotelCode',
          width: '140px'
        },
        {
          title: '商品信息',
          dataIndex: 'productInfo',
          width: '400px',
          ellipsis: true
        },
        {
          title: '来源',
          dataIndex: 'sourceName',
          width: '120px'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '180px'
        }
      ]
    }
  }
}
</script>

<style scoped></style>
